import { render, staticRenderFns } from "./AgentMoveCash.vue?vue&type=template&id=2fb6f420&scoped=true&"
import script from "./AgentMoveCash.vue?vue&type=script&lang=js&"
export * from "./AgentMoveCash.vue?vue&type=script&lang=js&"
import style0 from "./AgentMoveCash.vue?vue&type=style&index=0&id=2fb6f420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb6f420",
  null
  
)

export default component.exports